import React from 'react';
import moment from 'moment';
import { useObservableState } from 'observable-hooks';
import { tap } from 'rxjs/operators';
import { useTranslation } from 'react-i18next';
import { useService } from '../../../services/services';
import Article from '../../../interfaces/article';
import Paginate from '../../../interfaces/paginate';
import DashboardCard from '../components/dashboard-card';
import DashboardTitle from '../components/dashboard-title';
import Paging from '../../../components/common/paging';
import DashboardLoading from '../components/dashboard-loading';
import ArticleItem from './article-item';

export default function ArticleList() {
  const { t } = useTranslation();
  const { articleService } = useService();
  const [result] = useObservableState<Paginate<Article>>(
    () =>
      articleService.public().pipe(
        tap((res) => {
          res.data = res.data.map((item) => {
            return {
              ...item,
              created_at: moment(item.created_at).format('DD.MM.YYYY'),
            };
          });
          return res;
        })
      ),
    null
  );

  return (
    <DashboardCard theme="transparent" dataName={`articles-list`}>
      <DashboardTitle title={t('pages.dashboard.articles.heading')} />

      {!result?.data ? (
        <DashboardLoading />
      ) : result?.data.length ? (
        <>
          {result?.data.map((article, index) => (
            <ArticleItem article={article} key={`article-${index}`} />
          ))}
          <Paging response={result} hideRecords />
        </>
      ) : (
        <p>{t('No entries found')}</p>
      )}
    </DashboardCard>
  );
}
